export enum FileInputType {
  'ANY' = '',
  'PDF' = '.pdf',
  'CSV' = '.csv',
  'PNG' = '.png',
  'JPG' = '.jpg',
}
